import {z} from 'src/lib'
import {
  OperacionNotaEstructuradaCuentaFields,
  OperacionNotaEstructuradaDetalleFields,
  OperacionNotaEstructuradaFields,
  OperacionNotaEstructuradaLimiteFields
} from './fields'
import {EntityWithIdAndDescription, schemaEntityWithId} from 'src/types'
import {OperacionCLFBLimitesFields} from "../../../types/clfb";
import {OperacionCorporateCuentaFields} from "../../corporate/types/fields";

export const schemaOperacionNotaEstructurada = z
  .object({
    [OperacionNotaEstructuradaFields.CodPais]: z.number(),
    [OperacionNotaEstructuradaFields.NombrePais]: z.string(),
    [OperacionNotaEstructuradaFields.CodEstado]: z.number(),
    [OperacionNotaEstructuradaFields.CodSectorComercial]: z.number(),
    [OperacionNotaEstructuradaFields.NombreSectorComercial]: z.string(),
    [OperacionNotaEstructuradaFields.FechaVencimiento]: z.coerce.date(),
    [OperacionNotaEstructuradaFields.FechaAprobacion]: z.coerce.date(),
    [OperacionNotaEstructuradaFields.IdUsuarioAlta]: z.number(),
    [OperacionNotaEstructuradaFields.NombreUsuarioAlta]: z.string(),
    [OperacionNotaEstructuradaFields.ApellidoUsuarioAlta]: z.string(),
    [OperacionNotaEstructuradaFields.MailUsuarioAlta]: z.string(),
    [OperacionNotaEstructuradaFields.PermiteEditar]: z.boolean(),
    [OperacionNotaEstructuradaFields.PermiteEliminar]: z.boolean()
  })
  .merge(schemaEntityWithId)

export type OperacionNotaEstructurada = z.infer<typeof schemaOperacionNotaEstructurada>

export const schemaFormOperacionNotaEstructurada = z
  .object({
    [OperacionNotaEstructuradaFields.CodPais]: z.number(),
    [OperacionNotaEstructuradaFields.FechaAprobacion]: z.date(),
    [OperacionNotaEstructuradaFields.FechaVencimiento]: z.date(),
    [OperacionNotaEstructuradaFields.CodSectorComercial]: z.number(),
  })
  .refine(
    schema =>
      schema.fechaVencimiento ? schema.fechaVencimiento.getTime() >= schema.fechaAprobacion.getTime() : true, // No uso computed key porque: https://github.com/microsoft/TypeScript/issues/10530
    {
      message: 'La fecha de vencimiento debe ser mayor a la fecha de emisión.',
      path: [OperacionNotaEstructuradaFields.FechaVencimiento]
    }
  )

export type FormOperacionNotaEstructurada = z.infer<typeof schemaFormOperacionNotaEstructurada>

export const schemaNotaEstructuradaDetalle = z
  .object({
    [OperacionNotaEstructuradaDetalleFields.CodSeccion]: z.number(),
    [OperacionNotaEstructuradaDetalleFields.DescSeccion]: z.string(),
    [OperacionNotaEstructuradaDetalleFields.LimiteConcertacion]: z.number(),
    [OperacionNotaEstructuradaDetalleFields.LimiteDVP]: z.number(),
    [OperacionNotaEstructuradaDetalleFields.LimiteFOP]: z.number(),
    [OperacionNotaEstructuradaDetalleFields.PermiteModificar]: z.boolean(),
  })
  .merge(schemaEntityWithId)

export type OperacionNotaEstructuradaDetalle = z.infer<typeof schemaNotaEstructuradaDetalle>

export const schemaNotaEstructuradaDetalles = z.array(schemaNotaEstructuradaDetalle)

export type OperacionNotaEstructuradaLimite = EntityWithIdAndDescription & {
  [OperacionCLFBLimitesFields.LimiteImporte]: number
}

export type OperacionNotaEstructuradaLimiteVista = EntityWithIdAndDescription & {
  [OperacionNotaEstructuradaLimiteFields.LimiteImporte]: number
}

const schemaDetalle = z
  .object({
    [OperacionNotaEstructuradaCuentaFields.Sector]: z.string(),
    [OperacionNotaEstructuradaCuentaFields.ImporteConcertacion]: z.number(),
    [OperacionNotaEstructuradaCuentaFields.ImporteDPV]: z.number(),
    [OperacionNotaEstructuradaCuentaFields.ImporteFOP]: z.number(),
    [OperacionNotaEstructuradaCuentaFields.PermiteModificar]: z.boolean(),
    [OperacionNotaEstructuradaCuentaFields.Estilo]: z.string().nullable(),
  })
  .merge(schemaEntityWithId)

export type CuentaNotaEstructuradaDetalle = z.infer<typeof schemaDetalle>

export const schemaCuentaNotaEstructurada = z
  .object({
    [OperacionNotaEstructuradaCuentaFields.NroCuenta]: z.string(),
    [OperacionNotaEstructuradaCuentaFields.RazonSocial]: z.string(),
    [OperacionNotaEstructuradaCuentaFields.CodMoneda]: z.number(),
    [OperacionNotaEstructuradaCuentaFields.DescMoneda]: z.string(),
    [OperacionNotaEstructuradaCuentaFields.SimboloMoneda]: z.string(),
    [OperacionNotaEstructuradaCuentaFields.Detalles]: z.array(schemaDetalle)
  })
  .merge(schemaEntityWithId)

export const schemaCuentasNotaEstructurada = z.array(schemaCuentaNotaEstructurada)

export type CuentaNotaEstructurada = z.infer<typeof schemaCuentaNotaEstructurada>
export type CuentasNotaEstructurada = z.infer<typeof schemaCuentasNotaEstructurada>